<template>
<div class="el-tabs__inner">
  <b-row class="row-bg">
    <draggable  :list="availableFields" :clone="clone"
    :move="checkMove"
    class="dragArea" style="width: 100%"
    :group= "{ name:'formbuilder', pull:'clone', put:false }"
    :sort="false">
      <b-col cols="12" :data-section-id="field.sectionTagName" :class="{ 'is-disabled': checkStopDragCondition(field) }" v-for="(field, index) in availableFields" :key="index + '-' + field.tagname" class="mb-1">
        <b-button class="btn-block" variant="outline-info" @dblclick="addToBottomOfOwnSection(field)">
          {{ field.label ? field.label : field.text }}
        </b-button>
      </b-col>
    </draggable>
  </b-row>
</div>
</template>

<script>
  import {
  FormBuilder
} from '@/components/bs/formbuilder';
import draggable from 'vuedraggable';

export default {
  name: 'Templated',
  store: ['forms', 'fields', 'activeSectionTagName'],
  components: {
    draggable
  },
  mounted () {
    // console.log(FormBuilder.$data)
  },
  data() {
    return {
      dropElementOptions: FormBuilder.$data.dropElementOptions
    };
  },

  computed: {
    availableFields() {
      var used = this.forms.flatMap(s => s.fields).map(f => f.tagname)

      return this.fields.filter(f => {
        return f.sectionTagName === this.activeSectionTagName || !f.sectionTagName
      }).filter(f => {
        return used.indexOf(f.tagname) === -1 || !f.sectionTagName
      })
    }
  },

  methods: {
    addToBottomOfOwnSection (field) {
      var form = this.forms.find(f => f.tagName === this.activeSectionTagName)
      if(form) {
        form.fields.push(field)
      }
    },

    checkMove (event) {
      if(!event.dragged.dataset.sectionId) {
        return true
      }

      return event.to.id === event.dragged.dataset.sectionId
    },

    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    clone(field) {
      var cloned = _.cloneDeep(field);

      if(! cloned.id) {
        cloned.id = this.uuidv4()
      }

      return cloned
    },
    checkStopDragCondition(field) {
      var form = this.forms,
        formArray = [];

      for (var key in form) {
        formArray.push(form[key]['fieldType'])
      }
      // Check if the fieldname exist in formArray
      // And when the field.isUnique too
      return _.includes(formArray, field.name) && field.isUnique;
    }
  }
}
</script>

<style lang="scss" scoped>
.button__sidebar {
    width: 100%;
    margin-bottom: 5px;

    .is-disabled & {
        opacity: 0.4;
    }
}

// Display this ghost in <main> only
 .sortable__ghost {
    position: relative;
    width: 33.33%;
    border-bottom: 2px solid #3A8EE6;
    margin-top: 2px;
    margin-bottom: 2px;

    [type="button"] {
        display: none;
    }

    &:before {
        content: "Drag it here";
        background-color: #ECF5FF;
        color: #3A8EE6;
        position: absolute;
        left: 50%;
        font-size: 10px;
        border-radius: 10px;
        line-height: 15px;
        padding: 0 10px;
        top: -6px;
        transform: translateX(-50%);
    }
}
</style>
